import { render, staticRenderFns } from "./CsWrapper.vue?vue&type=template&id=4bd4279d"
import script from "./CsWrapper.vue?vue&type=script&lang=ts"
export * from "./CsWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports